import { frontendURL } from '../../../helper/URLHelper';
import { LAIS_STORIES_PERMISSIONS } from '../laisRouteHelpers';
import StoriesIndex from './pages/StoriesIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/stories'),
    alias: [
      frontendURL('accounts/:accountId/meus-stories'),
      frontendURL('accounts/:accountId/stories-corretor'),
      frontendURL('accounts/:accountId/vitrine/stories'),
    ],
    name: 'lais_stories_index',
    component: StoriesIndex,
    meta: { permissions: LAIS_STORIES_PERMISSIONS },
  },
];
